<template>
  <div>
    <div v-wechat-title="'六周年纪念章'"></div>
    <div class="five-anniversary-pc-page">
      <div class="main"></div>
    </div>
  </div>
</template>
<script>
import { getTimeStamp } from "@/utils/utils";
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      enterLink: ""
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      // 分享
      const { protocol, host } = window.location;
      this.enterLink = `${protocol}//${host}/snail/sixAnniversary/enter${getTimeStamp()}`;
      this.monitoringEquipment();
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
        if (navigator.userAgent.match(/(iPhone|iPod|mobile|Android|ios)/i)) {
          location.href = this.enterLink;
        }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "《最强蜗牛》六周年纪念奖章",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/7BjM8kVaE5122hic2slbpfCmfvyMjmBWeEoKXtZ3.png",
        desc: "六周年限定纪念奖章强势来袭！周年专属，错过再等一年！"
      });
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/sixAnniversary/pc/index.vue